import MainLayout from "components/shared/main-layout/MainLayout.jsx";
import { useContext, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoute from "./components/shared/PrivateRoute.jsx";
import ToastList from "./components/toast/ToastList.jsx";
import GuiContext from "./config/context/guiContext.js";
import PluginsContext from "./config/context/pluginsContext.js";
import ThemeContext from "./config/context/themeContext.js";
import ToastContext from "./config/context/toastContext.js";
import useFetch from "./config/useFetch.js";
import "./css/App.css";
// import AddComposition from "./pages/add-composition/AddComposition.jsx";
// import Compositions from "./pages/compositions/Compositions.jsx";
import DashboardPage from "./pages/dashboard/DashboardPage.jsx";
// import Databases from "./pages/DatabasesPage.jsx";
import Login from "./features/authentication/components/login/Login.jsx";
import NotFound from "./pages/not-found/NotFound.jsx";
import Plugins from "./pages/Plugins.jsx";
import Settings from "./pages/settings/Settings.jsx";
// import SetUpDatabase from "./pages/SetUpDatabase.jsx";
// import Templates from "./pages/templates/Templates.jsx";
import { Register } from "features/authentication/index.js";
import { Permissions } from "features/permissions/index.js";

import { AddCompositionView, CompositionsView } from "features/compositions/index.js";

const App = () => {
  const [onLine, setOnline] = useState(navigator.onLine);
  const { insertIntoToastList } = useContext(ToastContext);
  const { dark } = useContext(ThemeContext);
  const { saveActiveToContext } = useContext(PluginsContext);
  const {
    userData,
    selected,
    URL,
    userData: { guiname, id },
    selected: { selectedServer, selectedAccount },
  } = useContext(GuiContext);
  const {
    data: checkActive,
    error: checkActiveError,
    isLoading: checkActiveLoading,
    fetchData: fetchCheckActive,
  } = useFetch();
  const {
    data: checkVersion,
    error: checkVersionError,
    isLoading: checkVersionLoading,
    fetchData: fetchCheckVersion,
  } = useFetch();
  const {
    data: updateVersionRes,
    error: updateVersionError,
    isLoading: updateVersionLoading,
    fetchData: fetchUpdateVersion,
  } = useFetch();

  const updateGUIVersion = () => {
    const updateVersionURL = `${URL}/api/inerygui/update_version`;
    const updateVersionReqObj = {
      guiname: guiname,
      server_url: selectedServer,
      account_id: id,
    };
    fetchUpdateVersion(updateVersionURL, "POST", updateVersionReqObj);
  };

  useEffect(() => {
    const checkNetwork = () => {
      setOnline(navigator.onLine);
    };
    window.addEventListener("online", checkNetwork);
    window.addEventListener("offline", checkNetwork);

    return () => {
      window.removeEventListener("online", checkNetwork);
      window.removeEventListener("offline", checkNetwork);
    };
  }, []);

  //receno da se ugasi jer nema funkciju
  // useEffect(() => {
  //   if (!userData || Object.keys(userData).length === 0) {
  //     return;
  //   }
  //   const checkVersionURL = `${URL}/api/inerygui/version`;
  //   const checkVersionReqObj = { guiname: guiname };

  //   const timeoutId = setTimeout(() => {
  //     fetchCheckVersion(checkVersionURL, "POST", checkVersionReqObj);
  //   }, 500);

  //   return () => {
  //     clearTimeout(timeoutId);
  //   };
  // }, [userData, selected.selectedAccount]);

  useEffect(() => {
    if (checkVersionError) {
      insertIntoToastList(
        "Unable to check version",
        "error",
        "checkVersionError",
      );
    }
    if (!checkVersion) return;

    if (checkVersion.version_match === false) {
      let executable = true;
      let selfDestructible = false;
      insertIntoToastList(
        "You have outdated version of GUI, click here to update",
        "warning",
        "outdatedVersion",
        selfDestructible,
        executable,
        updateGUIVersion,
      );
    }
  }, [checkVersion, checkVersionError]);

  useEffect(() => {
    if (onLine) return;
    insertIntoToastList("Check your internet conection", "warning", "offline");
  }, [onLine]);

  useEffect(() => {
    //ako korisnik nije ulogovan...
    if (Object.keys(userData).length === 0) return;
    const checkActiveUrl = `${URL}/api/plugins/user`;
    const checkActiveBody = {
      guiname,
      server_url: selectedServer,
      account_id: id,
    };
    fetchCheckActive(checkActiveUrl, "POST", checkActiveBody);
  }, [selected]);

  // niz sa id-jevima aktivnih kompozicija cuvam u kontekstu
  //sluzi da prikaze sta mogu da koristim u settings-u
  useEffect(() => {
    if (!checkActive) return;
    const activetemp = [];
    for (const temp of checkActive.plugins) {
      if (temp.active === 1) {
        activetemp.push(temp.id);
      }
    }
    saveActiveToContext(activetemp, guiname);
  }, [checkActive]);

  useEffect(() => {
    if (!updateVersionRes) return;

    switch (updateVersionRes.updated_version) {
      case true:
        insertIntoToastList(
          "Your version is updated",
          "success",
          "updateOfVersionTrue",
        );

        break;
      case false:
        insertIntoToastList(
          "Unable to update version",
          "error",
          "updateOfVersionFalse",
        );

        break;
      default:
        return;
    }
  }, [updateVersionRes]);

  return (
    <div id="page" className={dark ? "dark" : "light"}>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route element={<PrivateRoute />}>
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            {/* <Route path="/databases" element={<Databases />} /> */}
            {/* <Route path="/set-up-database" element={<SetUpDatabase />} /> */}
            {/* <Route path="/compositions" element={<Compositions />} /> */}
            <Route path="/compositions" element={<CompositionsView />} />
            <Route path="/compositions/add-composition" element={<AddCompositionView />} />
            <Route path="/permissions" element={<Permissions />} />
            <Route path="/plugins" element={<Plugins />} />
            {/* <Route path="/templates" element={<Templates />} /> */}
            <Route path="/settings" element={<Settings />} />
            {/* <Route path="/add-composition" element={<AddComposition />} /> */}
          </Route>
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ToastList />
    </div>
  );
};

export default App;
